import Repository from "./RepositoryFactoryMain";

const CREATE_GATEWAY = "gateway/create";
const GET_GATEWAY = "gateway/get";
const GET_SINGLE_GATEWAY = "gateway/getSingle";
const EDIT_GATEWAY = "gateway/edit";
const DELETE_GATEWAY = "gateway/delete";
const SEND_EMAIL_GATEWAY = "gateway/sendEmail";

const RAZORPAY_CREATE_ORDER = "razorpay/createOrder";
const RAZORPAY_VERIFY_SIGNATURE = "razorpay/verifySignature";
const PAYU = "payu/payu";

export default {
  razorpayCreateOrder(payload) {
    return Repository.post(transformRoute(RAZORPAY_CREATE_ORDER), payload);
  },
  razorpayVerifySignature(payload) {
    return Repository.post(transformRoute(RAZORPAY_VERIFY_SIGNATURE), payload);
  },

  createGateway(payload) {
    return Repository.post(transformRoute(CREATE_GATEWAY), payload);
  },
  getPayULink(payload) {
    return Repository.post(transformRoute(PAYU), payload);
  },
  getGateway(payload) {
    return Repository.post(transformRoute(GET_GATEWAY), payload);
  },
  getSingleGateway(payload) {
    return Repository.post(transformRoute(GET_SINGLE_GATEWAY), payload);
  },
  editGateway(payload) {
    return Repository.post(transformRoute(EDIT_GATEWAY), payload);
  },
  deleteGateway(payload) {
    return Repository.post(transformRoute(DELETE_GATEWAY), payload);
  },
  sendEmail(payload) {
    return Repository.post(transformRoute(SEND_EMAIL_GATEWAY), payload);
  },
};

const transformRoute = (route) => {
  return `/payment/${route}`;
};
